import images from "../../images";

export const QuestionItem = ({
  name,
  type,
  question,
  iconUrl,
  handleDeleteQuest,
  handleEditQuest,
  // onClick,
}) => {
  return (
    <section className="overflow-hidden rounded-xl">
      <div className="flex w-full">
        <article
          // onClick={onClick}
          className={`flex relative p-3 bg-white rounded-xl border border-solid border-stone-200  ${
            handleDeleteQuest ? "w-4/5" : "w-full"
          }`}
        >
          <div className="flex-1">
            <div className="flex justify-between items-center mb-3">
              <div className="flex gap-1 items-center self-stretch my-auto text-sm font-medium text-indigo-600">
                {/* <img
                  src={images.QuestionIconQuestResult}
                  className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
                  alt={`Question icon`}
                /> */}
                <h2 className="self-stretch my-auto">{name}</h2>
              </div>
              <span className="gap-2.5 self-stretch px-2.5 py-1 my-auto text-xs leading-none whitespace-nowrap bg-yellow-50 rounded-md min-h-6 text-neutral-500 max-w-[80px]">
                {type}
              </span>
            </div>
            <div className="flex flex-row gap-2 items-center justify-between">
              <div>
                {" "}
                <p className="mt-3 text-xs text-neutral-500">{question}</p>
              </div>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  if (typeof handleEditQuest === "function") {
                    handleEditQuest();
                  } else {
                    console.warn(
                      "handleEditQuest is not a function",
                      handleEditQuest
                    );
                  }
                }}
                className="flex flex-col flex-1 shrink justify-center items-center basis-3 cursor-pointer max-w-[30px] w-full"
              >
                <div className="flex overflow-hidden flex-col items-center px-1.5 py-1.5 w-[30px]">
                  <img
                    src={images.PencilIconBlack}
                    alt=""
                    className="w-[30px]"
                  />
                </div>
              </div>
            </div>
          </div>
        </article>
        {handleDeleteQuest && (
          <div
            onClick={handleDeleteQuest}
            className="flex flex-col flex-1 shrink justify-center items-center basis-3"
          >
            <div className="flex overflow-hidden flex-col items-center px-1.5 py-1.5 w-[30px]">
              <img src={images.TrashIcon} alt="" className="w-[30px]" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
